export default __webpack_public_path__ + "images/datagrid-dummy-140.ba66e9c9e8388f54ee1b961cec961672.svg";